<template>
    <div class="loading-warp">
        <div class="loading-box">
            <div></div>
            <h1>即将进入投顾公司页面...</h1>
            <p><span>请稍等</span></p>
        </div>
    </div>
</template>
<script>
import "@/utils/flexible";
export default {
    name: ""
}
</script>
<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

.loading-warp {
    padding-top: 10px;
    background: $a-white;
    width: 100%;
    min-height: 100vh;

    .loading-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: $a-lfff-d121212;
        padding: 20px 0;
        box-sizing: border-box;

        div {
            background-image: url("https://cdncos.aigupiao.com/assets/app/svg/loading.svg");
            background-size: 60px;
            background-position: center;
            background-repeat: no-repeat;
            width: 60px;
            height: 60px;
            animation: rotateDom 1.5s linear infinite;
        }

        h1 {
            margin-top: 20px;
            font-size: 16px;
            line-height: 22px;
            color: $a-dl-f3-3;
        }

        p {
            margin-top: 10px;
            font-size: 13px;
            line-height: 18px;
            color: $a-l939393-d888;
        }
    }
}

@keyframes rotateDom {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}
</style>